import {CartItem} from './src/contexts/CartReducer'
import axios from '@/utils/axios'

const API = process.env.NEXT_PUBLIC_API_URL + '/cart' // Laravel route

const cart = {
  async addToCart(item: CartItem) {
    await axios.post(`${API}`, item)
  },

  async updateCartItem(item: CartItem) {
    await axios.put(`${API}/item/${item.uuid}`, item)
  },

  async removeCartItem(itemId: string) {
    await axios.delete(`${API}/item/${itemId}`)
  },

  async updateAddress(address: any) {
    await axios.put(`${API}/address`, address)
  },

  async updateCurrency(currency: string, shippingCountry: string) {
    await axios.put(`${API}/currency`, { 
      currency, 
      shipping_country: shippingCountry 
    });
  },

  async updateAddressType(
    address_type: 'pickup_point' | 'home_delivery' | 'self_pickup',
  ) {
    await axios.put(`${API}/address-type`, {address_type})
  },

  async applyCoupon(coupon: string) {
    await axios.post(`${API}/coupon`, {coupon})
  },

  async removeCoupon() {
    await axios.delete(`${API}/coupon`)
  },

  async emptyCart() {
    await axios.delete(`${API}`)
  },

  async fetchCart() {
    const response = await axios.get(`${API}`)
    return response.data
  },
}

export default cart
